module.exports = __webpack_public_path__ + "img/instagram-logo.bae9f05a.svg";